import React, { Component } from "react";
import { Link } from 'react-router-dom';
import Header from './Header';
import Menu from './Menu';
import NextPrev from './NextPrev';
import {QUESTION} from '../services/Questions';
import Check from './Check';
import Loader from './Loader';
import '../assets/css/question.css';
import '../assets/css/custom.css';
import SimpleReactValidator from 'simple-react-validator';
import {CONFIG, isTrueOrFalse,encryptPHI,decryptPHI} from "../helpers/Common"; 
import 'annotorious/css/annotorious.css';
import 'annotorious';
import $ from 'jquery';

let complain
class Questions extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
            questionData:'',
            totalQuestion:0,
            currentQuestionIndex:0,
            currentQuestion:'',
            currentQuestionOption:'',
            currentQuestionAnswer:'',
            questionAnswers: new Array(),
            updateQuestionAnswers: new Array(),
            complainDetails:this.props.getComplainData.complainTypeDetails,
            nextStep:5,
            prevStep:this.props.getComplainData.complainTypeDetails.image_front !=='' ? 3 : this.props.prev,
            is_multiselect:false,
            prefix:'',
            postfix:'',
            checkedItems: new Map(),
            prevQuestionIndexes: [],
            isLoading : true,
            showInput : 0,
            optionInputFields : new Array(),
            profileData: new Array(),
            boxesArray:[],
            imgPath: CONFIG.COMPLAIN_IMAGE_PATH,
            selectedBoxesFiltered:[],
            narrativeData:new Array(),
            resetNarrativeData:false,

        };
        // this.nextQuestion               = this.updateNextQuestion.bind(this);
        this.addCurrentOptionAnswers    = this.addCurrentOptionAnswers.bind(this);
        this.updateNextQuestion         = this.updateNextQuestion.bind(this);
        this.handlePrevAction           = this.handlePrevAction.bind(this);

        this.validator = new SimpleReactValidator();

    }

    componentWillMount()
    {
        // console.log('Question recieve Location Data as:',this.props.getComplainLocationData)

        if(this.props.getComplainData.complainTypeDetails.image_front ===''){
            localStorage.setItem('saveQuest',true);
        }
    
        //Get data from API's
        this.setState({
            profileData:this.props.getProfileData
        })
        complain=this.state.complainDetails
        let QuestionsData = QUESTION.getQuestionsByComplainType(this.state.complainDetails.id).then(res => {
        // console.log('Under Component will mount API hits')
            
            if(res.data.header.error==0)
            {


                //Set Question Data
                this.setState({
                    questionData: res.data.body.details,
                    isLoading: false,
                    resetNarrativeData:true
                });
                // console.log('After API hit, flag ',this.state.resetNarrativeData)
                this.setState({
                    totalQuestion: this.state.questionData.length,
                });
                // console.log('current flag ',this.state.resetNarrativeData)
                
                //Extract 1st Question a/c to paren_question_id = 0
                var ref = this;
                Object.values(res.data.body.details).forEach(function(row,key) 
                {   
                    let branchingData = row.branchingQuestionData;
                    if(branchingData.length === 0)
                    {
                        //_narrativeData = [];
                        let index = new Array();
                        index.push(key);
                        let multiSelect = (row.is_multiselect==1) ? true:false;
                        let myprefix = row.prefix;
                        let mypostfix = row.post;
                        const boxesArray=[];

                        if(row.is_image==="image_only"){

                            Object.values(row.options).forEach((item,key)=>{
                                if(item.image_options!==null){
                                boxesArray.push(item.image_options);
                                }

                            })
                        }

                        //Set 1st Question , Question Options,Current Question Index 
                        ref.setState({
                            currentQuestion: row,
                            currentQuestionOption: row.options,
                            is_multiselect:multiSelect,
                            single_line_text:row.single_line_text,
                            prevQuestionIndexes : index,
                            currentQuestionIndex:key,
                            prefix:myprefix,
                            postfix:mypostfix,
                            is_image:row.is_image,
                            boxesArray
                        });
                    }

                })

                //Set states If user comes from in-complate narrative/update 

                this.setState({
                    checkedItems: this.props.checkedItems,//default checked items
                    questionAnswers : this.props.questionAnswersData,//question answers of last complain types
                    optionInputFields : this.props.optionInputFields,//question option inputs fields text of last complain types
                    showInput : this.props.showInput,//question option inputs fields show of last complain types
                  });

                
                if(localStorage.getItem("data")){

                    var decryptedData = decryptPHI(CONFIG.ENCRYPTION_KEY,localStorage.getItem("data")); 

                    let data=JSON.parse(decryptedData);
                    console.log('All question local data',data)
                    console.log('this.props.getComplainData.complain_types',this.props.getComplainData.complain_types)
                    console.log('API questionData',this.state.questionData)
                    Object.values(data).forEach((item,key)=>{

                        if(parseInt(this.props.getComplainData.complain_types) === parseInt(item.complain_type)){

                          

                            let _questionAnswersMappedWithIndexes=[];
                            let _allCamplainAnswers=item.optionData;

                            Object.values(_allCamplainAnswers).forEach((innerItem,innerKey)=>{

                                Object.values(this.state.questionData).forEach((innerInnerItem,innerInnerKey)=>{

                                    if(Array.isArray(innerItem)){

                                        if(innerItem[0].question_id === innerInnerItem.id){
                                            _questionAnswersMappedWithIndexes[innerInnerKey]=innerItem;
                                        }

                                    }else{

                                        if(innerItem.question_id === innerInnerItem.id){
                                            _questionAnswersMappedWithIndexes[innerInnerKey]=innerItem;
                                        }
                                    }

                                });


                            });

                            this.props.setQuestionAnswersData(_questionAnswersMappedWithIndexes);
                            this.props.setCheckedItems(new Map(JSON.parse(item.checkedItems)));
                            // this.props.setComplainLocation(item.complainLocationData);

                            setTimeout(()=>{

                                this.setState({
                                   ...this.state,
                                    questionAnswers:this.props.questionAnswersData,
                                    checkedItems:new Map(JSON.parse(item.checkedItems))
                                });

                            },1000);

                        }

                    });
                }
                if(this.state.resetNarrativeData){
                    this.props.setNarrativeData([]);
                }
            }
            else
            {
                this.setState({
                    isLoading: false,
                });
                // alert('No Question Available');
            }
        }).catch(err => {
            this.setState({
                isLoading: false,
            });
            // alert('No Question Available');
            return err;
        });

        // if(this.state.resetNarrativeData){
        //     this.props.setNarrativeData([]);
        // }

    }
    handlePrevAction = (e)=>{
        this.props.handleNextPrevSteps(this.state.prevStep);
    }
    
    removeTags=(data,_narrativeText,single_line_text)=>
    {   
        if(single_line_text===true)
        {
            _narrativeText = data.single_line_text;
        }
       
        _narrativeText  =  _narrativeText.replace('<x>',data.required_input_text);
        _narrativeText  = this.replaceCommonTags(_narrativeText);

        return _narrativeText;

    }

    replaceCommonTags=(_narrativeText)=>
    {
        _narrativeText  =  _narrativeText.replace('<title>', this.state.profileData.title);
        _narrativeText  =  _narrativeText.replace('<name>', this.state.profileData.first_name+" "+this.state.profileData.last_name);
        _narrativeText  =  _narrativeText.replace('<fname>', this.state.profileData.first_name);
        _narrativeText  =  _narrativeText.replace('<lname>', this.state.profileData.last_name);
        _narrativeText  =  _narrativeText.replace('<gender>', this.state.profileData.gender.toLowerCase());
        if(this.state.profileData.gender==='Male')
        {
            _narrativeText  =  _narrativeText.replace('<his/her>', 'his');
            _narrativeText  =  _narrativeText.replace('<he/she>', 'he');
        }
        else
        {
            _narrativeText  =  _narrativeText.replace('<his/her>', 'her');
            _narrativeText  =  _narrativeText.replace('<he/she>', 'she');

        }

        return _narrativeText;
    }
    updateNextQuestion    = () =>
    {
        if (this.validator.allValid()) {

        }else{
            this.validator.showMessages();
            return;
        }

        let questionData = this.state.questionData;
        let addQuestionInArray = true;

        let checkedItems = this.state.checkedItems;
        let _questionOptions = this.state.currentQuestionOption;
        // console.log('_questionOptions',_questionOptions)
        var ref = this;
        Object.values(_questionOptions).forEach( (row,key) =>
        {   
            if(ref.state.checkedItems.get(row.id))
            {
                // console.log('Updaet Next question "ref.state.checkedItems"')
                // console.log('row :',row)
                
                //ref.addCurrentOptionAnswers.bind(this,row.id,key,row.narrative_text,row.parent_question_id,row.required_input,row.sort_order)
                //let gender = (profileData.gender).toLowerCase(); 
                const answers                   = new Array();
                let _narrativeText  = row.narrative_text;

                if(Array.isArray(row) && isTrueOrFalse(row.is_multiselect)){
                    // console.log('if multi select question ')
                    if(row.length>1){
                    // console.log('multiselect with more than 1 selection')
                        
                        let narrativeText=row[0].prefix;
                        // console.log('narrativeText for multi select',narrativeText)

                        row.forEach((item,key)=>{
                            narrativeText= narrativeText + item.narrative;

                        });

                        // narrativeText = narrativeText + row[0].postfix;

                        // _narrativeText  =  _narrativeText.replace('<x>', narrativeText );

                    }else{

                   
                       //  _narrativeText  =  _narrativeText.replace('<x>', row[0].single_line_text );
                    }

                }else{

                // _narrativeText  =  _narrativeText.replace('<x>', ref.state.optionInputFields[row.id]);

                }
                // _narrativeText  =  _narrativeText.replace('<title>', ref.state.profileData.title);
                // _narrativeText  =  _narrativeText.replace('<name>', ref.state.profileData.first_name+" "+ref.state.profileData.last_name);
                // _narrativeText  =  _narrativeText.replace('<gender>', ref.state.profileData.gender.toLowerCase());
                // if(ref.state.profileData.gender=='Male')
                // {
                //     _narrativeText  =  _narrativeText.replace('<his/her>', 'his');
                //     _narrativeText  =  _narrativeText.replace('<he/she>', 'he');
                // }
                // else
                // {
                //     _narrativeText  =  _narrativeText.replace('<his/her>', 'her');
                //     _narrativeText  =  _narrativeText.replace('<he/she>', 'she');

                // }

                answers.push({
                    option_id:row.id,
                    question_id:row.question_id,
                    is_multiselect:isTrueOrFalse(row.is_multiselect),
                    single_line_text:row.single_line_text,
                    prefix:ref.state.currentQuestion.prefix,
                    postfix:ref.state.currentQuestion.postfix,
                    sort_order:row.sort_order,
                    narrative_text:_narrativeText,
                    parent_question_id:row.parent_question_id,
                    required_input:row.required_input,
                    required_input_text:ref.state.optionInputFields[row.id],
                });
                // console.log('answer array',answers)
                if(localStorage.getItem('saveQuest')=='true')
                {
                // console.log('saveQuest check')

                    if(localStorage.getItem('newData')==''||localStorage.getItem('newData')==null){
                        let newData=[]
                        newData.push({complainType:complain.name,answere:answers})
                       // var encryptedNewData = encryptPHI(CONFIG.ENCRYPTION_KEY,JSON.stringify(newData));
                        localStorage.setItem('newData',JSON.stringify(newData));
                        
                        localStorage.setItem('saveQuest','false')
                    }

                    else{
                        if(localStorage.getItem('editQuest')=='true')
                        {
                            // console.log('here this.state.complainDetails',this.state.complainDetails)
                            let newData =localStorage.getItem('newData')
                            newData = JSON.parse(newData) 
                            // loop in local data          --> /`/ 
                            var decryptedData = decryptPHI(CONFIG.ENCRYPTION_KEY,localStorage.getItem("data")); 
                            let data=JSON.parse(decryptedData);
                            // console.log('data here',data)
                            newData.forEach((element,key) => {
                                
                                if(this.state.complainDetails.name == element.complainType){
                                    // console.log('complainType item here',element.complainType)
                                    newData[key]={complainType:complain.name,answere:answers}
                                    
                                }

                            });
                     // /`/ newData[newData.length-1]={complainType:complain.name,answere:answers}
                            
                            // newData.push({complainType:null,answere:answers})
                            //var encryptedNewData = encryptPHI(CONFIG.ENCRYPTION_KEY,JSON.stringify(newData));
                            localStorage.setItem('newData',JSON.stringify(newData))
                             
                            localStorage.setItem('saveQuest','false')
                            localStorage.setItem('editQuest','false')
                        }
                        else{
                            let newData =localStorage.getItem('newData')
                            //var decryptedNewData = decryptPHI(CONFIG.ENCRYPTION_KEY,newData);

                            newData = JSON.parse(newData) 
                            newData.push({complainType:complain.name,answere:answers})
                           // var encryptedNewData = encryptPHI(CONFIG.ENCRYPTION_KEY,JSON.stringify(newData));

                            localStorage.setItem('newData',JSON.stringify(newData))
                            localStorage.setItem('saveQuest','false')
                        }
                     
                    }
                   
                    
                }
                // newdata
                const _questionAnswers           = ref.state.questionAnswers;
                // if(answers.length > 0){
                //     _questionAnswers[ref.state.currentQuestionIndex] = answers;
                // }else{
                // _questionAnswers[ref.state.currentQuestionIndex] = answers[0];
                // }

                ref.setState({
                    questionAnswers : _questionAnswers
                });
               
            }
            
        });
        // console.log('state, questionAnswers',this.state.questionAnswers)
       //Check user select any option for current question
        if(this.state.questionAnswers[this.state.currentQuestionIndex])
        {
            let currentQuestionIndex    = this.state.totalQuestion;
            let prevQuestionIndexes     = this.state.prevQuestionIndexes;
            const questionAnswers       = this.state.questionAnswers;
            const updateQuestionAnswers = this.state.updateQuestionAnswers;
            let currentQuestionAnswer   = this.state.questionAnswers[this.state.currentQuestionIndex];

            let _narrativeData          = this.props.narrativeData;
            let _ref                    = this;
            // console.log('questionAnswers is ',questionAnswers)
            questionAnswers.forEach(function(row,key) 
            {
                if(key === _ref.state.currentQuestionIndex){

                    let _narrative = "";
                    if ("option_id" in row)
                    {
                        _narrative = row.narrative_text;
                        _narrative = _ref.removeTags(row,_narrative,false);
                        _narrativeData.push(_narrative)
                    }
                    else
                    {

                        if(row.length===1)
                        {
                            _narrative = row[0].narrative_text;
                            _narrative = _ref.removeTags(row[0],_narrative,false);
                            _narrativeData.push(_narrative)
                        }
                        else
                        {
                            let _narrativetxt = ''
                            let multiNarrative = [];
                            row.forEach(function(item,k)
                            {


                                _narrativetxt = item.narrative_text;
                                _narrativetxt = _ref.removeTags(item,_narrativetxt,true);
                                multiNarrative.push(_narrativetxt)


                            })
                            let narLength = multiNarrative.length;
                            let lastIndexNarrative = multiNarrative[narLength-1];
                            multiNarrative.pop();

                            _narrative +=multiNarrative.join(', ')+" and "+lastIndexNarrative;
                            let prefix  = "";
                            let postfix  = "";
                            if(row[0].prefix!=null)
                            {
                                prefix      = ref.replaceCommonTags(row[0].prefix) ? ref.replaceCommonTags(row[0].prefix) : "";
                                _narrative  = prefix+" "+_narrative;
                            }
                            if(row[0].postfix!=null)
                            {
                                postfix     = ref.replaceCommonTags(row[0].postfix) ? ref.replaceCommonTags(row[0].postfix) : "";
                                //_narrative  = _narrative+" "+postfix.trim();
                                postfix = postfix.trim();
                                if(postfix =='.' || postfix =='?'|| postfix =='.<br>'|| postfix =='. <br>'|| postfix =='?<br>'|| postfix =='? <br>'|| postfix =='. <br> <br>'|| postfix =='? <br> <br>'|| postfix =='.<br> <br>'|| postfix =='?<br> <br>'){
                                    _narrative  = _narrative+postfix;
                                }else{
                                    _narrative  = _narrative+" "+postfix; 

                                } 
                            }

                            _narrativeData.push(_narrative)
                            // console.log('Question All _narrativeData: ',_narrativeData) 

                        }

                            // console.log('Question All narative: ',_narrative)
                    }
                }
               
            });
           
            this.setState({narrativeData : _narrativeData})
         
            //Check option have required input
            if(Array.isArray(this.state.questionAnswers[this.state.currentQuestionIndex])){

                this.state.questionAnswers[this.state.currentQuestionIndex].every((item)=>{

                    //Check option have required input
                    if(item.required_input==1 )
                    {
                        if(!item.required_input_text)
                        {
                            addQuestionInArray = false;
                        }
                    }
                    if(!addQuestionInArray)
                    {
                        alert('please fill input field');
                        return false;
                    }

                    return true;

                });

            }else{

                //Check option have required input
                if(currentQuestionAnswer.required_input==1 )
                {
                    if(!currentQuestionAnswer.required_input_text)
                    {
                        addQuestionInArray = false;
                    }
                }

            }

            if(!addQuestionInArray)
            {
                alert('please fill input field');
            }
            else
            {
                //const answers               = new Array();
                //answers.push(this.state.questionAnswers[this.state.currentQuestionIndex]);
                
                /** updateQuestionAnswers this is only for when user update narrative */
                updateQuestionAnswers[this.state.currentQuestionIndex] = this.state.questionAnswers[this.state.currentQuestionIndex];
                
                // console.log('Question All _narrativeData: ',_narrativeData) 
                // console.log('At the end _narrativeData to update props',_narrativeData)
                //updateQuestionAnswers.push(this.state.questionAnswers[this.state.currentQuestionIndex]);
                this.setState({...this.state, updateQuestionAnswers : updateQuestionAnswers,narrativeData:_narrativeData , resetNarrativeData:false});
                this.props.setNarrativeData(_narrativeData);

                /** Extract next question option */
                let selectedOptionId    = currentQuestionAnswer.option_id;
                let selectedQuestionId  = currentQuestionAnswer.question_id;
                
                Object.values(questionData).forEach(function(row,key) 
                {   
                    let branchingQuestionData = row.branchingQuestionData;

                    let addedToArray=false;
                    Object.values(branchingQuestionData).forEach(function(r,k)
                    {

                        /** In first Condition For Multi Select We skip to check parent question option id. We just Check parent_question in branching Logic */
                        if(ref.state.is_multiselect && r.parent_question_id == ref.state.currentQuestion.id && !addedToArray)
                        {
                            /** Extract next question index */
                            currentQuestionIndex = key;
                            prevQuestionIndexes.push(key);

                            addedToArray=true;

                        }
                        else{
                            if(
                                r.parent_question_option_id == selectedOptionId &&
                                r.parent_question_id        == selectedQuestionId
                                )
                                {
                                    /** Extract next question index */
                                    currentQuestionIndex = key;
                                    prevQuestionIndexes.push(key);
                                }

                        }
                    });
                    
                })
                //let currentQuestionIndex = this.state.currentQuestionIndex+1;
                if(currentQuestionIndex < this.state.totalQuestion)
                {   
                    
                    this.setState({
                        prevQuestionIndexes : prevQuestionIndexes
                    })
                    /** Set next question here */
                    this.updateCurrentQuestion(currentQuestionIndex);
                }
                else
                {   
                    /** SAVE ALL DATA IN MASTER COMPONENT AND GO TO PATIENT NARRATIVE*/    
                    this.props.setCheckedItems(this.state.checkedItems);
                    this.props.setOptionInputFields(this.state.optionInputFields);
                    this.props.setInputField(this.state.showInput);
                    
                    if(this.props.isNarrativeUpdate)
                    {  
                        this.props.setQuestionAnswersData(this.state.questionAnswers);
                        
                    }
                    else
                    {   
                        this.props.setQuestionAnswersData(this.state.questionAnswers);
                    }
                    this.props.handleNextPrevSteps(this.state.nextStep);
                }
            }


        }
        else
        {
            alert('please select at least one option');
        }

    } 
    updatePrevQuestion = (props) =>
    {   
       
        let prevQuestionIndexes = this.state.prevQuestionIndexes;
        let narrativeData           = this.state.narrativeData;
        const lastIndex         = prevQuestionIndexes[(prevQuestionIndexes.length)-1];
        prevQuestionIndexes.pop();
        narrativeData.pop();
        this.setState({
            narrativeData:narrativeData
        })
        if(prevQuestionIndexes.length > 0)
        {   
            let questionAnswers = this.state.questionAnswers;
            // delete questionAnswers[lastIndex];
            let currentQuestionIndex = prevQuestionIndexes[(prevQuestionIndexes.length)-1]
            this.setState({
                prevQuestionIndexes : prevQuestionIndexes,
                questionAnswers : questionAnswers,
                narrativeData:narrativeData
            })
            
            this.setState({
                currentQuestionIndex:currentQuestionIndex,
            });
            this.updateCurrentQuestion(currentQuestionIndex);
        }
        else
        {
            this.handlePrevAction();
        }
        // else
        // {
        //     this.setState({
        //         currentQuestionIndex:0
        //     })
        // }

        this.checkAndMarkBoxes();

    } 

    checkAndMarkBoxes=()=>{

        if(this.state.is_image==="image_only" && this.state.boxesArray.length>0){

            // window.anno.makeAnnotatable(document.getElementById('boxespic'));


            this.showPoints(this.state.boxesArray);

            $('body').on('change','.img-point',null,(event)=>{

                const option_id = event.target.value;

                Object.values(this.state.currentQuestion.options).forEach((item,key)=>{

                    if(item.image_options!==null){

                        if(item.image_options.option_id === parseInt(option_id)){


                            let flag=false;
                            let i=0;


                            for(i=0;i<this.state.selectedBoxesFiltered.length;i++){

                                if(this.state.selectedBoxesFiltered[i].id === item.id){
                                    flag=true;
                                    break;
                                }
                            }

                            if(flag){

                                let selectedBoxes=this.state.selectedBoxesFiltered.filter((innerItem,innerKey)=>{

                                    if(innerItem.id === item.id){

                                        return false;

                                    }else{

                                        return true;
                                    }

                                });

                                // this.state.questionAnswers[this.state.currentQuestionIndex]


                                this.setState({...this.state,selectedBoxesFiltered:selectedBoxes});


                                this.addCurrentOptionAnswersForBoxes(item.id,key,item.narrative_text,item.question_id,item.required_input,this.state.currentQuestion.category_order,
                                    this.state.is_multiselect,this.state.currentQuestion.prefix,this.state.currentQuestion.postfix,item.single_line_text,selectedBoxes);


                            }else{

                                let mutatedItem={...item,
                                    option_id:item.id,multiSelect:this.state.is_multiselect,
                                    single_line_text:item.single_line_text,
                                    prefix:this.state.currentQuestion.prefix,
                                    postfix:this.state.currentQuestion.postfix,
                                    question_id:item.question_id,
                                    sort_order:item.sort_order,
                                    narrative_text:item.narrative_text,
                                    parent_question_id:item.question_id,
                                    required_input:item.required_input,
                                    required_input_text:this.state.optionInputFields[item.id]
                                };

                                this.setState({...this.state,selectedBoxesFiltered:[...this.state.selectedBoxesFiltered,mutatedItem]});

                                setTimeout(()=>{

                                    this.addCurrentOptionAnswersForBoxes(item.id,key,item.narrative_text,item.question_id,item.required_input,this.state.currentQuestion.category_order,
                                        this.state.is_multiselect,this.state.currentQuestion.prefix,this.state.currentQuestion.postfix,item.single_line_text,this.state.selectedBoxesFiltered);

                                },500);

                            }

                            // let myQuestionAnswers=[...this.state.questionAnswers];

                            // console.log(myQuestionAnswers,"MyQuestionAnswers")

                        }
                    }

                });


            });


            // Object.values(this.state.boxesArray).forEach((item,key)=>{
            //
            //     console.log(item,"InnerItem");
            //
            //     let myAnnotation = {
            //         /* The URL of the image where the annotation should go */
            //         src : this.state.imgPath + item.image_src,
            //
            //         image_map_id : item.id,
            //
            //         /* The annotation text */
            //         text : item.label,
            //
            //         /* The annotation shape */
            //         shapes : [{
            //             /* The shape type */
            //             type : 'rect',
            //
            //             /* The shape geometry (relative coordinates) */
            //             geometry : { x : item.coordinate_x, y: item.coordinate_y, width :item.coordinate_width, height: item.coordinate_height }
            //         }]
            //     };
            //
            //     window.anno.addAnnotation(myAnnotation, "");
            //
            // });
            //
            // window.anno.setSelectionEnabled(false);
            // console.log(window.anno.getActiveSelector(),"ActiveSelector");
            //
            // $('body').on('click','canvas.annotorious-item-focus',null,(event)=>{
            //
            //     console.log("YAHOOO");
            //     console.log($('div.annotorious-popup').css('opacity'),"Opacity");
            //
            //     if($('div.annotorious-popup').css('opacity')==='0.9'){
            //
            //         if($('canvas.annotorious-item-focus').attr("data")==="true"){
            //             $('canvas.annotorious-item-focus').attr("data","false");
            //         }else{
            //             $('canvas.annotorious-item-focus').attr("data","true");
            //         }
            //         // $('canvas.annotorious-item-focus').addClass('tullo');
            //
            //         const label_text=$('.annotorious-popup-text').text();
            //         let option_id;
            //
            //         console.log($('.annotorious-popup-text').text());
            //
            //         this.state.boxesArray.forEach((item,key)=>{
            //
            //             if(item.label===label_text){
            //                 option_id=item.option_id;
            //             }
            //
            //         });
            //
            //         // let myQuestionAnswers=[...this.state.questionAnswers];
            //
            //     }
            //
            // })

        }

    }

    addInputTextInOptionAnswers = (e,multiSelect,optionId,originalItem)=>
    {   
        const currentQuestionIndex      = this.state.currentQuestionIndex;
        const questionAnswers           = this.state.questionAnswers;
        if(multiSelect){

            questionAnswers[currentQuestionIndex] = questionAnswers[currentQuestionIndex].map((item)=>{


                if(optionId === item.option_id){

                    // item.required_input_text=e.target.value;
                    return {...item,required_input_text:e.target.value};

                }else{
                    return item;
                }
            });


        }else{
        questionAnswers[currentQuestionIndex]['required_input_text'] = e.target.value;
        }
        let inputFields = this.state.optionInputFields;
        inputFields[e.target.id] = e.target.value;
        this.setState({
            optionInputFields : inputFields
        });
        
    } 
    addCurrentOptionAnswers             = (id,key,narrative_text,parentQuestionId,required_input,sort_order,multiSelect,prefix,postfix,single_line_text) =>
    {   
        const optionId                  = id;
        const parent_question_id        = parentQuestionId;
        const optionIndex               = key;
        const questionId                = this.state.currentQuestion.id;
        const currentQuestionIndex      = this.state.currentQuestionIndex;
        const questionAnswers           = this.state.questionAnswers;
        
        // Show input field if reuried input 1
        this.setState({
            showInput:optionId
        })


        const answers       = new Array();
        let _narrativeText  = narrative_text;
        
        
        answers.push({
            option_id:optionId,
            multiSelect:multiSelect,
            single_line_text,
            prefix,postfix,
            question_id:questionId,
            sort_order:sort_order,
            narrative_text:_narrativeText,
            parent_question_id:parent_question_id,
            required_input:required_input,
            required_input_text:this.state.optionInputFields[optionId],
        });

        if(multiSelect){

            if(questionAnswers[currentQuestionIndex]===undefined || questionAnswers[currentQuestionIndex].length===0){

                questionAnswers[currentQuestionIndex]=[];
            }

            if(id===optionId && !this.state.checkedItems.get(id)){
                questionAnswers[currentQuestionIndex] = [...questionAnswers[currentQuestionIndex],answers[0]];
            }else if(id===optionId && this.state.checkedItems.get(id)){
                questionAnswers[currentQuestionIndex] = questionAnswers[currentQuestionIndex].filter((item)=>{
                    return item.option_id !== id;
                })
            }

        }else{

        questionAnswers[currentQuestionIndex] = answers[0];

        }


        this.setState({
            questionAnswers : questionAnswers
        });

        var ref = this;

        if(multiSelect){
            this.setState(prevState => ({

                    checkedItems: prevState.checkedItems.set(id,!prevState.checkedItems.get(id)) }
            ));
        }else{
            Object.values(this.state.currentQuestionOption).forEach(function(row,key)
            {
                ref.setState(prevState => ({

                        checkedItems: prevState.checkedItems.set(row.id,) }
                ));
            })
            this.setState(prevState => ({

                    checkedItems: prevState.checkedItems.set(id,!prevState.checkedItems.get(id)) }
            ));
        }
    }

    addCurrentOptionAnswersForBoxes             = (id,key,narrative_text,parentQuestionId,required_input,sort_order,multiSelect,prefix,postfix,single_line_text,boxesArray) =>
    {
        const optionId                  = id;
        const parent_question_id        = parentQuestionId;
        const optionIndex               = key;
        const questionId                = this.state.currentQuestion.id;
        const currentQuestionIndex      = this.state.currentQuestionIndex;
        const questionAnswers           = this.state.questionAnswers;

        // Show input field if reuried input 1
        this.setState({
            showInput:optionId
        })


        // const answers       = new Array();
        // let _narrativeText  = narrative_text;
        // _narrativeText.replace('<x>', this.state.optionInputFields[optionId]);
        // _narrativeText.replace('<title>', this.state.profileData.title);
        // _narrativeText.replace('<name>', this.state.profileData.first_name+" "+this.state.profileData.last_name);
        // answers.push({
        //     option_id:optionId,
        //     multiSelect:multiSelect,
        //     single_line_text,
        //     prefix,postfix,
        //     question_id:questionId,
        //     sort_order:sort_order,
        //     narrative_text:narrative_text,
        //     parent_question_id:parent_question_id,
        //     required_input:required_input,
        //     required_input_text:this.state.optionInputFields[optionId],
        // });

        questionAnswers[currentQuestionIndex] = boxesArray;

        //
        // if(multiSelect){
        //
        //     if(questionAnswers[currentQuestionIndex]===undefined || questionAnswers[currentQuestionIndex].length===0){
        //
        //         questionAnswers[currentQuestionIndex]=[];
        //     }
        //
        //     if(id===optionId && !this.state.checkedItems.get(id)){
        //         questionAnswers[currentQuestionIndex] = [...questionAnswers[currentQuestionIndex],answers[0]];
        //     }else if(id===optionId && this.state.checkedItems.get(id)){
        //         questionAnswers[currentQuestionIndex] = questionAnswers[currentQuestionIndex].filter((item)=>{
        //             return item.option_id !== id;
        //         })
        //     }
        //
        // }else{
        //
        //     questionAnswers[currentQuestionIndex] = boxesArray;
        //
        // }


        this.setState({
            questionAnswers : questionAnswers
        });

        var ref = this;

        if(multiSelect){
            this.setState(prevState => ({

                    checkedItems: prevState.checkedItems.set(id,!prevState.checkedItems.get(id)) }
            ));
        }else{
            Object.values(this.state.currentQuestionOption).forEach(function(row,key)
            {
                ref.setState(prevState => ({

                        checkedItems: prevState.checkedItems.set(row.id,) }
                ));
            })
            this.setState(prevState => ({

                    checkedItems: prevState.checkedItems.set(id,!prevState.checkedItems.get(id)) }
            ));
        }
    }
    
    
    updateCurrentQuestion   = (index) => 
    {   
        
        const currentQuestion   = this.state.questionData[index];
        const questionOption    = this.state.questionData[index].options;
        const is_multiselect = isTrueOrFalse(this.state.questionData[index].is_multiselect);
        const prefix  = currentQuestion.prefix;
        const postfix= currentQuestion.postfix;

        const boxesArray=[];

        if(currentQuestion.is_image==="image_only"){

            Object.values(currentQuestion.options).forEach((item,key)=>{

                if(item.image_options!==null){
                boxesArray.push(item.image_options);
                }
            })
        }

        this.setState({
            currentQuestionIndex:index,
            currentQuestion: currentQuestion,
            currentQuestionOption: questionOption,
            is_multiselect,
            prefix:prefix,postfix:postfix,
            is_image:currentQuestion.is_image,
            boxesArray

        });

        setTimeout(()=>{

            this.checkAndMarkBoxes();

        },500)
        
    }
    displayInputText = (id)=>
    {
        return this.state.optionInputFields[id];
    }

    makeSeletedItemList=(selectedArray)=>{
        if (selectedArray === undefined || selectedArray.length == 0) {
            return null;
        }else {
            return (selectedArray.map((item) => {
                return (<div className="point-close"><div>{item.image_options.label}</div>
                    <span onClick={(event) => {
                        $(".marker" + item.label).remove();
                        // this.setState({
                        //     ...this.state, selectedLocation: this.state.selectedLocation.filter((i) => {
                        //         return item.id !== i.id;
                        //     })
                        // });
                    }}>&#10060;</span></div>)
            }));
        }
    };

    showPoints(pointsArray) {
        for (var i = 0; i < pointsArray.length; i++) {

            let found=false;

            if(this.state.questionAnswers[this.state.currentQuestionIndex]!=null && Array.isArray(this.state.questionAnswers[this.state.currentQuestionIndex])
            && this.state.questionAnswers[this.state.currentQuestionIndex].length>0){

                Object.values(this.state.questionAnswers[this.state.currentQuestionIndex]).forEach((item,key)=>{

                    if(item.id === pointsArray[i].option_id){

                        found=true;
                    }

                });
            }

            var topPercent = pointsArray[i].top;
            var leftPercent = pointsArray[i].left;
            var isChecked = found ? 'checked' : '';
            $('.js-point-img-container').append('<div style="top: ' + topPercent + '%; left: ' + leftPercent + '%;" class="img-point">\
            <input '+ isChecked +' type="checkbox" value="' + pointsArray[i].option_id + '" id="point-id-' + i + '" name="points" >\
            <label for="point-id-' + i + '"><span>Point</span></label>\
        </div>');
        }
    }

    handleOnClickPoint=(event)=>{

        // console.log("ITSCLICKED");

    };

  render() {
      var style = {
          'minWidth':'100%',
          'width':'auto',
      }
    return (
        <React.Fragment>
            <Header title="Interview Questions" titleImage="ic-conversation.png" />
            <Menu />
            <section className="chief-complain sec--question">
                {/* <div className="banner" >
                    <img src={require("../assets/img/bg/new-banner-question.jpg")} style={style} alt="" />
                </div> */}
                <div className="questionrow">
                    <div className="question">
                        <label>Question</label>
                        <h3>{this.state.currentQuestion.name}</h3>
                    </div>
                </div>
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    {
                      this.state.isLoading!=0 &&
                      <Loader/>
                    }
                </div>

                

                    <div className="content">
                    <div className="multybgRow">

                        {this.state.currentQuestion.is_image === "image_only" ?
                            <div className="container">
                                <div className="male-img">
                                    <section className="c-show-points-layout">
                                        <div className="point-img-wrapper js-point-img-container">
                                            <img id="boxespic" src={this.state.imgPath + this.state.currentQuestion.image_front} alt="Human Body"/>
                                        </div>
                                    </section>
                                </div>
                            </div>
                            :
                            <ul className="checkList">
                                {

                                    Object.values(this.state.currentQuestionOption).sort((a, b) => a.sort_order - b.sort_order).map((item, i) => (
                                        <Check displayInputText={this.displayInputText}
                                               multiSelect={this.state.is_multiselect} validator={this.validator}
                                               validation_rules={item.required_input_rules}
                                               parent_question_id={item.parent_question_id}
                                               addInputTextInOptionAnswers={this.addInputTextInOptionAnswers}
                                               key={item.id} item={item} i={i}
                                               prefix={this.state.currentQuestion.prefix}
                                               postfix={this.state.currentQuestion.postfix}
                                               single_line_text={item.single_line_text}
                                               addCurrentOptionAnswers={this.addCurrentOptionAnswers}
                                               checked={this.state.checkedItems.get(item.id)}
                                               showInput={this.state.showInput}
                                               sort_order={this.state.currentQuestion.category_order}
                                        />

                                    ))}
                            </ul>
                        }
                    </div>
                </div>
            </section>
            
            <div className="sec-btn">
            
                <Link to="#" className="btn-img" onClick={this.updatePrevQuestion}>
                    <img src={require("../assets/img/icons/ic-prev.png")} alt="" />
                </Link>
            
            
            {
                (this.state.totalQuestion > 0 && this.state.currentQuestionIndex < this.state.totalQuestion) &&
                <Link to="#" className="btn-img " onClick={this.updateNextQuestion} >
                    <img src={require("../assets/img/icons/ic-next.png")} alt="" />
                </Link>
            }
                
            </div>

        </React.Fragment>
    );
  }
}

export default Questions;